import React, { useEffect, useState } from 'react'
import Draw from 'ol/interaction/Draw';
import Overlay from 'ol/Overlay';
import {LineString, Polygon} from 'ol/geom';
import {getArea, getLength} from 'ol/sphere';
import {unByKey} from 'ol/Observable';
import {Circle as CircleStyle, Fill, Stroke, Style} from 'ol/style';

import { lineDrawLayer } from '../../Map/Layers/LineDrawLayer';
import MyMap from '../../Map/Views/MyMap';
import { Feature } from 'ol';
import { crosshairCursor } from '../../../Utils/CursorUtils';

const selectedTitleStyle = {
  backgroundColor:'rgb(35, 156, 213)'
}

let draw; 
let F_INDEX = 0
const alanStyle = (color) => {
  return [
    new Style({
      fill: new Fill({
        color: color,
      }),
      stroke: new Stroke({
        color: '#89d1d6',
        width: 2,
      }),
      image: new CircleStyle({
        radius: 7,
        fill: new Fill({
          color: '#89d1d6',
        }),
      }),
    })
  ]
}

const cizgiStyle = (color) => {
  return [
    new Style({
      fill: new Fill({
        color: 'rgba(0, 102, 153, 0.2)',
      }),
      stroke: new Stroke({
        color: color,
        width: 2,
      }),
      image: new CircleStyle({
        radius: 7,
        fill: new Fill({
          color: '#89d1d6',
        }),
      }),
    })
  ]
}


export default function SidebarOlcumler() {

    const [selectedPage,setSelectedPage] = useState(null) // 1: Uzunluk, 2:Alan
    const [features,setFeatures] = useState([])

    let sketch;
    
    let measureTooltipElement;
    
    let measureTooltip;
    
    const addInteraction = (val) => {
      let tip = val === 1 ? 'LineString' : 'Polygon'
    draw =  new Draw({
        source: lineDrawLayer.getSource(),
        type: tip,
        style: new Style({
          fill: new Fill({
            color: 'rgba(255, 255, 255, 0.2)',
          }),
          stroke: new Stroke({
            color: 'rgba(0, 0, 0, 0.5)',
            lineDash: [10, 10],
            width: 4,
          }),
          image: new CircleStyle({
            radius: 5,
            stroke: new Stroke({
              color: 'rgba(0, 0, 0, 0.7)',
            }),
            fill: new Fill({
              color: 'rgba(255, 255, 255, 0.2)',
            }),
          }),
        }),
        
      });

      createMeasureTooltip();


      var listener;
      draw.on('drawstart', function (evt) {
        // set sketch
        sketch = evt.feature;
        console.log(sketch)
        /** @type {import("../src/ol/coordinate.js").Coordinate|undefined} */
        var tooltipCoord = evt.coordinate;
    
        listener = sketch.getGeometry().on('change', function (evt) {
          var geom = evt.target;
          var output;
          if (geom instanceof Polygon) {
            output = formatArea(geom);
            tooltipCoord = geom.getInteriorPoint().getCoordinates();
          } else if (geom instanceof LineString) {
            output = formatLength(geom);
            tooltipCoord = geom.getLastCoordinate();
          }
          measureTooltipElement.innerHTML = output;
          measureTooltip.setPosition(tooltipCoord);
        });
      });

      draw.on('drawend', function (evt) {
        sketch = evt.feature;
        console.log('FEATURE EKLEDİ')
        F_INDEX = F_INDEX+1
        lineDrawLayer.getSource().addFeature(new Feature(
          {
            geometry:sketch.getGeometry(),
            tip:sketch.getGeometry().getType(),
            id:F_INDEX,
            result:sketch.getGeometry().getType() === 'Polygon' ? formatArea(sketch.getGeometry()) : formatLength(sketch.getGeometry()) 
          }
        ))

        setFeatures(lineDrawLayer.getSource().getFeatures())
        
        measureTooltipElement.className = `ol-tooltip ol-tooltip-static t${F_INDEX}`;
        measureTooltip.setOffset([0, -7]);
        // unset sketch
        sketch = null;
        // unset tooltip so that a new one can be created
        measureTooltipElement = null;
        unByKey(listener);
        createMeasureTooltip(F_INDEX);
      });
      MyMap.addInteraction(draw)
    }
    

      var formatArea = function (polygon) {
        var area = getArea(polygon,{projection:'EPSG:3857'});
        var output;
        if (area > 10000) {
          output = Math.round((area / 1000000) * 100) / 100 + ' ' + 'km²';
        } else {
          output = Math.round(area * 100) / 100 + ' ' + 'm²';
        }
        return output;
      };

      const formatLength = function (line) {
        const length = getLength(line,{projection:'EPSG:3857'})
        let output;
        if (length > 100) {
          output = Math.round((length / 1000) * 100) / 100 + ' ' + 'km';
        } else {
          output = Math.round(length * 100) / 100 + ' ' + 'm';
        }
        return output;
      };
      

      function createMeasureTooltip() {
        if (measureTooltipElement) {
          measureTooltipElement.parentNode.removeChild(measureTooltipElement);
        }
        measureTooltipElement = document.createElement('div');
        measureTooltipElement.className = 'ol-tooltip ol-tooltip-measure';
        measureTooltip = new Overlay({
          element: measureTooltipElement,
          offset: [0, -15],
          positioning: 'bottom-center',
        });
        MyMap.addOverlay(measureTooltip);
      }
      

    const onClickTitle = async (page) => {
      await cleanInteractions()
      if(selectedPage === page){
        setSelectedPage(0)
        crosshairCursor(false)
        return
      }
      crosshairCursor(true)
      setSelectedPage(page)
      addInteraction(page)
    }

    // Haritada çizim etkileşimlerini kaldırır
    let cleanInteractions = () => {
      MyMap.getInteractions().getArray().filter(d=> d === draw ).map(interaction => {
        return MyMap.removeInteraction(interaction)
      })
    }

    // Çizimlerin üzerindeki göstergeyi siler.
    let cleanToolTip = (id) => {
      if(id === undefined){
        const elements = document.getElementsByClassName('ol-tooltip');
        while(elements.length > 0){
            elements[0].parentNode.removeChild(elements[0]);
        }
      } else {
        const elements = document.getElementsByClassName('t'+id);
        while(elements.length > 0){
            elements[0].parentNode.removeChild(elements[0]);
        }
      }
    }


    const removeFeatureFunc = async (f) => {
      let features = lineDrawLayer.getSource().getFeatures()
      let i = features.indexOf(f)
      console.log(f)
      if(f.getGeometry().getType === 'Polygon'){
        await lineDrawLayer.getSource().removeFeature(features[i])
      } else {
        await lineDrawLayer.getSource().removeFeature(features[i])
        await lineDrawLayer.getSource().removeFeature(features[i+1])
      }
      cleanToolTip(f.get('id'))
      setFeatures(lineDrawLayer.getSource().getFeatures())
    }
    
    // INPUT Üzerinden FEATURE'a ait renk değiştirildiği zaman
    const onChangeColor = (feature,color) => {

      let selectedFeature = lineDrawLayer.getSource().getFeatures().find(f => f === feature)
      if(selectedFeature === null || selectedFeature === undefined ){
        // Geometri Bulunamadı.
        return
      } else {

      // ALAN ise Fill Color
      if(feature.getGeometry().getType() === 'Polygon'){
        selectedFeature.setStyle(alanStyle(color))

      // ÇİZGİ ise Stroke Color
      } else {
        selectedFeature.setStyle(cizgiStyle(color))

      }
    }
  }

  // Gelen tipe ait feature ve DOM'ları kaldır.
  const onClickRemoveAllFeatures = (type) => {
    console.log(type)
    console.log(lineDrawLayer.getSource().getFeatures().filter(d=> d.get('tip') === type))
    lineDrawLayer.getSource().getFeatures().filter(d=> d.get('tip') === type).map((f,i) => {
      return removeFeatureFunc(f)
    })
  }

    useEffect(() => {
        let isMounted = true
        if(isMounted){
          cleanInteractions()
            MyMap.addLayer(lineDrawLayer)

        }
        return () => {
            isMounted = false
            cleanToolTip()
            crosshairCursor(false)
            MyMap.removeLayer(lineDrawLayer)
            cleanInteractions()
            lineDrawLayer.getSource().clear()            
            

          }
    }, [])

    return (
    <div className='row'>

        <div className="col-12">
            <div className='sideBarFormTitle'>
                Hesaplama
            </div>
        </div>

        <div className="col-12" >
          <div id='adaParselTitle' className="formTitleAlt" style={selectedPage === 1 ? selectedTitleStyle : null} onClick={()=> onClickTitle(1)}>Uzunluk</div>
        </div>
      {selectedPage === 1 ?
        <div className='col-12'>
          <table className='table table-sm table-bordered' style={{borderColor:'rgba(255,255,255,0.1)',fontSize:'11px'}} >
            <tbody>

              {features.filter(d=> d.get('result') !== undefined && d.getGeometry().getType() === 'LineString').map((d,i)=>{
                return  <tr key={i} >
                          <td style={{width:'50px'}} >
                          <input type="color" defaultValue={'#89d1d6'}  onChange={(e)=> onChangeColor(d,e.target.value)}  />
                          </td>
                          <td>
                            {d.get('result')}
                          </td>
                          <td style={{width:'50px'}}>
                            <button className='btn btn-danger btn-sm' style={{fontSize:'11px'}}  onClick={()=> removeFeatureFunc(d)} >Sil</button>
                          </td>
                        </tr>
              })}

              {features.filter(d=> d.get('result') !== undefined && d.getGeometry().getType() === 'LineString').length !== 0 ?
                <tr>
                  <td colSpan={'3'}  >
                    <div className='d-flex justify-content-end' >
                    <button className='btn btn-warning btn-sm' onClick={()=> onClickRemoveAllFeatures('LineString')} style={{fontSize:'11px'}} >Tümünü Sil</button>
                    </div>
                  </td>
                </tr>
              :<i>Hesaplanacak mesafeyi haritada çiziniz.</i>}
              
            </tbody>
          </table>
        </div>
      :null}


        <div className="col-12" >
          <div id='adaParselTitle' className="formTitleAlt" style={selectedPage === 2 ? selectedTitleStyle : null} onClick={()=> onClickTitle(2)}>Alan</div>
        </div>

      {selectedPage === 2 ?
        <div className='col-12'>
          <table className='table table-sm table-bordered' style={{borderColor:'rgba(255,255,255,0.1)',fontSize:'11px'}} >
            <tbody>
              {features.filter(d=> d.get('result') !== undefined && d.getGeometry().getType() === 'Polygon').map((d,i)=>{
                return  <tr key={i} >
                          <td style={{width:'50px'}} >
                          <input type="color" defaultValue={'#006699'}  onChange={(e)=> onChangeColor(d,e.target.value)}  />
                          </td>
                          <td>
                            {d.get('result')}
                          </td>
                          <td style={{width:'50px'}}>
                            <button className='btn btn-danger btn-sm' style={{fontSize:'11px'}} onClick={()=> removeFeatureFunc(d)}>Sil</button>
                          </td>
                        </tr>
              })}
              {features.filter(d=> d.get('result') !== undefined && d.getGeometry().getType() === 'Polygon').length !== 0 ?
                <tr>
                  <td colSpan={'3'}  >
                    <div className='d-flex justify-content-end' >
                    <button className='btn btn-warning btn-sm' onClick={()=> onClickRemoveAllFeatures('Polygon')} style={{fontSize:'11px'}} >Tümünü Sil</button>
                    </div>
                  </td>
                </tr>
              :<i>Hesaplanacak alanı haritada çiziniz.</i>}
            </tbody>
          </table>
        </div>
        
      :null}

    </div>
    )
}
